import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';
import { spaceMonitoringService } from '@/api/services/serverless/space-monitoring';

export const Route = createFileRoute(
  '/_authenticated/_dashboard/accounts/$accountId/serverless-spaces/$spaceId/_tabs/overview',
)({
  validateSearch: z.object({
    createApiKey: z.coerce.boolean().nullish(),
  }),
  beforeLoad: ({ params }) => ({
    spaceSummaryMetricsQuery: spaceMonitoringService.getSpaceSummaryMetricsQuery(params),
  }),
  // Not awaited: the overview renders its skeletons while the metrics load.
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(context.spaceSummaryMetricsQuery);
  },
  component: lazyRouteComponent(() => import('./overview.component'), 'SpaceOverviewComponent'),
});
